import React from "react";
import { Check } from "lucide-react";
import { getThemeSurface } from "../../utils/themes";

// Shrinks the real link-card style down to swatch scale (same radius and style, thinner border/shadow).
const miniCardStyle = (themeItem) => {
  const card = getThemeSurface(themeItem).card;
  return {
    ...card,
    border: card.border && card.border !== "none" ? card.border.replace(/^[\d.]+px/, "1.5px") : card.border,
    boxShadow: card.boxShadow?.replace("4px 4px 0", "2px 2px 0"),
  };
};

const ThemeSwatch = ({ themeItem, selected, onSelect }) => (
  <button
    type="button"
    onClick={onSelect}
    aria-label={themeItem.name}
    aria-pressed={selected}
    title={themeItem.name}
    className={
      "relative w-full h-14 rounded-xl flex flex-col items-center justify-center gap-1 px-2 transition focus:outline-none focus:ring-2 focus:ring-indigo-300 shadow-sm " +
      (selected
        ? "ring-2 ring-indigo-500 ring-offset-2"
        : "ring-1 ring-black/5 hover:ring-slate-300")
    }
    style={{ background: themeItem.gradient }}
  >
    <span className="block w-full h-4" style={miniCardStyle(themeItem)}></span>
    <span
      className="text-[9px] font-semibold leading-none capitalize"
      style={{ color: themeItem.text }}
    >
      {themeItem.name}
    </span>
    {selected && (
      <span className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-indigo-600 text-white flex items-center justify-center">
        <Check className="w-2.5 h-2.5" strokeWidth={3.5} />
      </span>
    )}
  </button>
);

export default ThemeSwatch;
